export default class HeaderTemplates {
	static headerContactsTelContainer(cityId, tel1, tel2 = null) {
		let result = (`<a class="header-contacts-dropdown_tel ${cityId}-phone-1" href="tel:${tel1}">${tel1}</a>`);

		if (tel2) {
			result += (`<a class="header-contacts-dropdown_tel ${cityId}-phone-2" href="tel:${tel2}">${tel2}</a>`);
		} else {
			result += (`<p class="header-contacts-dropdown_tip">${craft.localization.freeCalls}</p>`);
		}

		return result;
	}
}